import { render, staticRenderFns } from "./editadministrator.vue?vue&type=template&id=3bf955de&scoped=true&"
import script from "./editadministrator.vue?vue&type=script&lang=js&"
export * from "./editadministrator.vue?vue&type=script&lang=js&"
import style0 from "./editadministrator.vue?vue&type=style&index=0&id=3bf955de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf955de",
  null
  
)

export default component.exports